import React from 'react';
import _ from 'lodash';

import _masterSlideLoader from '../../utilities/masterSlideLoader';
import { AnchorList } from './AnchorList';
import {
  isLoginUserBranch,
  isLoginUserPrime,
} from '../../utilities/roleUtility';
import dialogLoader from '../../utilities/dialogLoader';
import { CloseEditView } from '../CloseEditView';
import UserProfileService from '../../services/UserProfiles';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import SessionStorageService from '../../services/utilities/SessionStorageService';

/**
 * 会社情報確認メニュー
 * @props {boolean}isSelectedHeadOfficeInformation:本社情報を選択済みにするか？
 * @props {boolean}isSelectedBranchOfficeInformation:支店情報を選択済みにするか？
 * @props {boolean}isSelectedCcusManagementInfo:CCUS連携情報を選択済みにするか？
 * @props {boolean}isSelectedDeleteKmobileDevice
 * @props {boolean}isEditable:編集中かどうか？
 */
export class PrimaryCompanyNaviList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: '',
      propsState: Object.create(null),
      isUseGreenFileService: false,
    };
    this.userId = LocalStorageService.getUserId();
    this.companyId = SessionStorageService.getCompanyId();
    this.isKajima = SessionStorageService.isKajimaCompany();
  }

  confirmMoveToPage = (pageName, propsState) => {
    if (this.props.isEditable !== undefined && this.props.isEditable === true) {
      let state = { ...this.state };
      state.pageName = pageName;
      state.propsState = propsState;
      this.setState(state, () => {
        dialogLoader.show(CloseEditView, {
          callback: {
            close: () => {
              this.stayThisPage();
              dialogLoader.close();
            },
            clear: () => {
              this.moveToPage();
              dialogLoader.close();
            },
          },
        });
      });
    } else {
      _masterSlideLoader.show(pageName, {
        state: propsState,
      });
    }
  };

  moveToPage = () => {
    const state = { ...this.state };
    if (state.pageName === 'PrimeCcusPreview' && this.props.onConfirm) {
      this.setState(state);
      this.props.onConfirm();
    } else {
      _masterSlideLoader.show(state.pageName, {
        state: state.propsState,
      });
    }
  };

  stayThisPage = () => {
    const state = { ...this.state };
    state.pageName = '';
    state.propsState = Object.create(null);
    this.setState(state);
  };

  setUseGreenFileService = async () => {
    let isUseGreenFileService = false;
    if (isLoginUserPrime() || isLoginUserBranch()) {
      const param = {};
      if (this.companyId > 0) {
        param.company_id = this.companyId;
      }
      const response = await UserProfileService.show(this.userId, param);
      if (response.result) {
        const entity = response.data.entities;
        isUseGreenFileService = !!_.get(entity, 'use_greenfile_flg');
      }
    }
    this.setState({ isUseGreenFileService });
  };

  componentDidMount() {
    this.setUseGreenFileService();
  }

  render() {
    const {
      isSelectedHeadOfficeInformation,
      isSelectedCcusManagementInfo,
      isSelectedPrimeSafetySettingInfo,
      isSelectedBranchOfficeInformation,
      isSelectedDeleteKmobileDevice,
      expirationCompany,
    } = this.props;
    const { isUseGreenFileService } = this.state;

    return (
      <React.Fragment>
        <ul className='contruction-navi-list PrimaryCompanyNaviList'>
          <AnchorList
            label={data.menuTitle.headOfficeInformation}
            isSelected={isSelectedHeadOfficeInformation}
            onClick={() => this.confirmMoveToPage('PrimeCompanyPreview', {})}
            warningText={
              isUseGreenFileService &&
              _.has(this.props, 'expirationCompany') &&
              _.some([
                expirationCompany.has_expired_company_safety,
                expirationCompany.has_about_to_expire_company_safety,
              ])
                ? expirationCompany.has_expired_company_safety
                  ? '期限切れの情報があります。'
                  : '期限切れ間近の情報があります。'
                : ''
            }
            warningIcon={
              isUseGreenFileService &&
              _.has(this.props, 'expirationCompany') &&
              _.some([
                expirationCompany.has_expired_company_safety,
                expirationCompany.has_about_to_expire_company_safety,
              ]) && (
                <WarningIcon
                  color={
                    expirationCompany.has_expired_company_safety
                      ? 'warning'
                      : 'caution'
                  }
                />
              )
            }
          />
          {isLoginUserPrime() && (
            <AnchorList
              label={data.menuTitle.ccusManagementInfo}
              isSelected={isSelectedCcusManagementInfo}
              className='PrimaryCompanyNaviList__children__text'
              onClick={() => this.confirmMoveToPage('PrimeCcusPreview', {})}
            />
          )}
          {isUseGreenFileService && (
            <AnchorList
              label={data.menuTitle.primeSafetySettingInfo}
              isSelected={isSelectedPrimeSafetySettingInfo}
              className='PrimaryCompanyNaviList__children__text'
              onClick={() =>
                this.confirmMoveToPage('PrimeSafetySettingPreview', {})
              }
            />
          )}
          {this.isKajima && isLoginUserPrime() && (
            <AnchorList
              label={data.menuTitle.deleteKmobileDevice}
              isSelected={isSelectedDeleteKmobileDevice}
              className='PrimaryCompanyNaviList__children__text'
              onClick={() => this.confirmMoveToPage('DeleteKmobileDevice', {})}
            />
          )}
          <AnchorList
            label={data.menuTitle.branchOfficeInformation}
            isSelected={isSelectedBranchOfficeInformation}
            onClick={() => this.confirmMoveToPage('PrimeBranchPreview', {})}
          />
        </ul>
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  menuTitle: {
    headOfficeInformation: '本社情報',
    branchOfficeInformation: '支店情報',
    ccusManagementInfo: 'CCUS連携情報',
    primeSafetySettingInfo: '労務安全項目',
    deleteKmobileDevice: 'K-Mobile端末管理',
  },
};

const WarningIcon = props => {
  const { color } = props;
  return (
    <div
      className={`PartnerNaviList__warning-icon PartnerNaviList__warning-icon--${color}`}
    >
      <i className='icon-warning_round' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/list/PrimaryCompanyNaviList.jsx